import { Box, Button, Dialog, DialogContent, DialogTitle, IconButton, Stack, TextField } from "@mui/material";
import { useContext, useState } from "react";
import { CloseIcon } from "../../../minimals/theme/overrides/CustomIcons";
import { UserContext } from "../../contexts/UserContext";
import NotesTimeline from "../../checks/checkNotes/NotesTimeline";
import { LedgerNote } from "./types";
import { DashboardNote } from "../../checks/types";
import { saveEscrowLedgerNote } from "../../reports/escrowLedgers/saveNote";

function processNoteUserAndText(note: LedgerNote) {
  const noteTextParts = note.text?.split("added this note: ");
  const createdByUser = noteTextParts?.length > 1 ? noteTextParts[0] : note.createdBy.replace("WORKGROUP\\", "");
  const text = noteTextParts?.length > 1 ? noteTextParts[1] : noteTextParts[0];
  return {
    createdByUser,
    text
  };
}

interface IProps {
  open: boolean;
  orderNumberDisplay?: string;
  amount?: string;
  refetchData?: Function;
  onClose: () => void;
  title: string;
  notes: LedgerNote[];
}

export default function NotesModal({ orderNumberDisplay, amount, open, refetchData, onClose, title, notes }: IProps) {
  const [submitting, setSubmitting] = useState(false);
  const { user } = useContext(UserContext);
  const [text, setText] = useState<string>("");

  const save = async () => {
    setSubmitting(true);
    await saveEscrowLedgerNote(orderNumberDisplay!!, text, user?.name!!);
    setSubmitting(false);
    if (refetchData) {
      refetchData();
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>
        <Box>{title}</Box>
      </DialogTitle>
      <IconButton
        onClick={onClose}
        sx={{ position: "absolute", right: 8, top: 8, color: (theme) => theme.palette.grey[500] }}
      >
        <CloseIcon />
      </IconButton>

      <DialogContent sx={{ paddingBottom: 3 }}>
        <Box paddingTop={1}>
          <TextField
            value={text}
            onChange={(e) => setText(e.target.value)}
            fullWidth
            multiline
            rows={3}
            label="Note"
            sx={{ marginBottom: 2 }}
          />
          <Stack direction="row" justifyContent="right">
            <Button variant="contained" size="small" onClick={save} disabled={submitting}>
              {submitting ? "Saving..." : "Save"}
            </Button>
          </Stack>
        </Box>
        <NotesTimeline
          notes={
            notes.map(
              (n) =>
                ({
                  id: n.id,
                  // selectId: n.ledgerId,
                  dateCreated: n.dateCreated,
                  ...processNoteUserAndText(n)
                } as unknown as DashboardNote)
            ) || []
          }
        />
      </DialogContent>
    </Dialog>
  );
}
